<div class="feedback-time-editor-slider-container">
	<mat-slider
		#slider
		color="primary"
		class="feedback-time-editor-slider"
		[thumbLabel]="false"
		[(ngModel)]="time"
		[min]="0"
		[max]="duration"
		(input)="updateTime($event)"
		(change)="updateTime($event)"
		[attr.aria-label]="'feedback-session-feedback-tree-comment_new-time-handle' | translate"
		[step]="1000">
	</mat-slider>
	<div class="custom-thumb-controls" [style.left]="getThumbPosition(slider)">
		<button
			type="button"
			class="thumb-btn decrement-btn"
			[attr.aria-label]="'feedback-item_time-editor-decrement' | translate"
			(click)="decrement()">
			–
		</button>
		<span class="time-display">{{formatLabel(time)}}</span>
		<button
			type="button"
			class="thumb-btn increment-btn"
			[attr.aria-label]="'feedback-item_time-editor-increment' | translate"
			(click)="increment()">
			+
		</button>
	</div>
	<span class="begin-and-end-time">
		<span class="begin-time">{{formatLabel(0)}}</span>
		<span class="end-time">{{formatLabel(duration)}}</span>
	</span>
</div>
<div class="feedback-time-editor-actions">
	<button class="tertiary-btn cancel-btn" (click)="cancel()" translate="common_cancel"></button>
	<button class="primary-btn save-btn" (click)="save()" translate="common_save"></button>
</div>